import "./Accordion.ts";
import "./HeaderMenu.ts";
import "./LottiePlayer.ts";
import "./Map.ts";
import ScrollToTop from "./ScrollToTop.ts";
import "./SwiperGalleries.ts";
import "./ShareButton.ts";
import "./KPI.ts";

if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log("HMR");
    });
}

const backToTopButton = document.getElementById("BackToTop");
if (backToTopButton) {
    new ScrollToTop(backToTopButton);
}
